// document.addEventListener('DOMContentLoaded', function(){
//   // タブに対してクリックイベントを適用
//   const tab01 = document.getElementsByClassName('js-tab-01');
//   for(let i = 0; i < tab01.length; i++) {
//     tab01[i].addEventListener('click', tabSwitch, false);
//   }

//   // タブをクリックすると実行する関数
//   function tabSwitch(){
//     // タブのclassの値を変更
//     document.getElementsByClassName('is-active')[0].classList.remove('is-active');
//     this.classList.add('is-active');
//     // コンテンツのclassの値を変更
//     document.getElementsByClassName('is-show')[0].classList.remove('is-show');
//     const arrayTabs = Array.prototype.slice.call(tab01);
//     const index = arrayTabs.indexOf(this);
//     document.getElementsByClassName('js-panel-01')[index].classList.add('is-show');
//   };
// }, false);

// 商品ページ before/afterの挙動
$(function() {
  $('.p-productBa__tabBtn').on('click', function() {
    var tabWrap = $(this).parents('.p-productBa__tabWrap');
    var tabBtn = tabWrap.find(".p-productBa__tabBtn");
    var tabContents = tabWrap.find('.p-productBa__tabContent');
    tabBtn.removeClass('is-active');
    $(this).addClass('is-active');
    var elmIndex = tabBtn.index(this);
    tabContents.removeClass('is-active');
    tabContents.eq(elmIndex).addClass('is-active');
  });
});
